import React from "react";
import { StreamProvider } from "@teamrota/shiftstreamlib";
import { cleanAddress } from "../../utils";

export const Provider = ({ account }: { account: any }) => {
  const name =
    account.provider !== StreamProvider.EMAIL ? (
      <>
        <a href={account.url} target="_blank" rel="noreferrer">
          {account.provider} - {account.name}
        </a>
      </>
    ) : (
      <>
        {account.provider} - {account.name}
      </>
    );

  return (
    <>
      <img
        title={account.name}
        src={`/images/shiftstream/${account.provider}.png`}
        alt={`${account.provider} logo`}
        style={{ height: 30, marginRight: 10, verticalAlign: "middle" }}
      />
      <div style={{ display: "inline-block", verticalAlign: "middle" }}>
        <div>{name}</div>

        <div style={{ fontSize: "70%" }}>
          {account.provider === StreamProvider.EMAIL ? (
            <>
              Email:{" "}
              <span style={{ fontWeight: "bold" }}>
                {cleanAddress(account.url)}
              </span>
            </>
          ) : (
            <>
              Login: <span style={{ fontWeight: "bold" }}>{account.login}</span>
            </>
          )}
        </div>
      </div>
    </>
  );
};
